export const iconFontAwesomeWeatherCloudShowersWater = (
	<i className="fa-solid fa-cloud-showers-water"></i>
);
